import { render, staticRenderFns } from "./MealDetail.vue?vue&type=template&id=614a16a7&scoped=true&"
import script from "./MealDetail.vue?vue&type=script&lang=js&"
export * from "./MealDetail.vue?vue&type=script&lang=js&"
import style0 from "./MealDetail.vue?vue&type=style&index=0&id=614a16a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a16a7",
  null
  
)

export default component.exports